import React from "react";
import Calendar from 'react-calendar';
import { datesAreTheSame } from "../../../helpers/Dates";



const ReactCalendar = ({className, selectedDates, setSelectedDates, isSelectPastOnly, isSelectFutureOnly, isSingleDateSelect}: {className?: string, selectedDates?: Date[], setSelectedDates:(dates:Date[])=> void, isSelectPastOnly?: boolean, isSelectFutureOnly?: boolean, isSingleDateSelect?: boolean}) => {   
    function dateClick(date:Date){
        let sorted:Date[] = [];

        if(selectedDates?.length === 2) {
            selectedDates = [];
        }

        if (selectedDates) {
            sorted = [...selectedDates, date].sort((a,b) => a.getTime() - b.getTime())
        }
        else {
            sorted = [date]
        }
        
        if (sorted.length >= 2){
            if (datesAreTheSame(sorted[0], sorted[1])){
                    sorted = [sorted[0]]
            }
        }
        setSelectedDates(sorted)
    }

    function formatDefaultValue(): any {
        const value: Date[] = [];
        if(selectedDates?.[0]) {
            value.push(new Date(selectedDates[0].toDateString()))
        }
        if(selectedDates?.[1]) {
            value.push(new Date(selectedDates[1].toDateString()))
        }

        if (value.length === 1) {
            return value [0]
        } 
        else if (value.length === 2) {
            return value
        }

        return undefined
    }

    return (
        <div className="thrive-react-calendar">
            <Calendar
                className={className}
                onClickDay={(value: Date) => dateClick(value)}
                showWeekNumbers
                showNeighboringMonth={false}
                selectRange={isSingleDateSelect ? false : true}
                minDate={isSelectFutureOnly ? new Date() : undefined}
                maxDate={isSelectPastOnly ? new Date() : undefined}
                maxDetail="month"
                minDetail="month"
                prev2Label={null}
                next2Label={null}
                value={formatDefaultValue()}
            />
            
        </div>
    );
};

export default ReactCalendar